import React, { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import useNavProject from '../../../hooks/useNavProject';
import useAPI from '../../../hooks/useAPI';
import useUserContext from '../../../hooks/useUserContext';
import IncomesRegister from './WidgetsPages/IncomesRegister';
import ProjectRequests from './WidgetsPages/ProjectRequests';
import ArticlesRegister from './WidgetsPages/ArticlesRegister';
import { useProjectForNav } from '../../../hooks/useProjectForNav';
import { useStore } from '../../../stores/StoreHelpers';
import { getProjectPerms, hasPermsOnIndexesOrReceipts, isAdminReadRestricted, isCommandManagmentOrProjOffice } from '../../../services/rolesSvc';
import ForbiddenAccess from '../../../components/ForrbiddenAccessComponent/ForbiddenAccess';
import UnifiedProjTable from './WidgetsPages/UnifiedProjTable';
import Receipts from "../../../components/table/Receipts";
import ReceiptsAddContract from '../../../components/ReceiptsAddContract';
import ProjectReportWidgets from '../../../components/project/ProjectReportWidgets';
import ReportYear from '../../../components/ProjectReportTabs/ReportYear';
import MilestonesTable from '../../../components/project/Widgets/Milestones/MilestonesTable';
import ReceiptEdit from '../../../components/ReceiptEdit';
import EditFactForm from '../../../components/project/Widgets/Milestones/EditFactForm';
import { BaseRequests } from '../../../requests/BaseRequests';
import BackBtn from '../../../components/UI/BackBtn';

function PortfProjReportWidgetPage() {
  const {
    stratId,
    portfolioId,
    projId,
    type,
    reportYear
  } = useParams();
  const userCtx = useUserContext();
  const navProject = useNavProject();
  const api = useAPI();
  const proj = useProjectForNav(api, navProject, projId);
  const store = useStore();
  const [project, setProject] = useState(null);
  const [permissions, setPermissions] = useState(null);

  const checkPortfProjectWidgetsPerms = (userCtx, stratId, projId, portfolioId) => isCommandManagmentOrProjOffice(
    userCtx, stratId, projId, portfolioId
  ) || isAdminReadRestricted(userCtx);

  useEffect(async () => {
    const respProject = await api.get(`/structure/projs/${projId}`);
    if (!respProject || respProject.error) return;
    setPermissions(getProjectPerms(userCtx, respProject.id, respProject.strategy?.id, respProject.portfolio?.id));
    setProject(respProject);
    BaseRequests.getNavigationLinks(respProject, navProject);
  }, []);

  useEffect(() => {
    store.articles.clearStoreOnCardExit();
    store.incomeProj.clearIncomeOnExitCard();
  }, [store.articles, store.incomeProj]);
  const content = [
    !!project && {
      type: `year`,
      header: 'Ежегодный отчёт',
      content: <ReportYear
        stratId={stratId}
        title={project.name}
        projectId={project.id}
        permissions={{
          canRead: permissions.canRead,
          canEdit: permissions.canWrite,
        }}
        role={{
          strategy: permissions.strategyRole,
          project: permissions.projectRole,
        }}
        reportYear={reportYear ? parseInt(reportYear) : 2022}
      />,
      show: () => permissions.canRead || permissions.canWrite,
    },
    {
      type: 'articles',
      show: checkPortfProjectWidgetsPerms,
      header: 'Статьи',
      content: <ArticlesRegister proj={proj} projName={navProject?.portfProjTitle ?? ''} stratId={stratId} projId={projId} portfolioId={portfolioId}/>
    },
    {
      type: 'requests',
      header: 'Заявки',
      show: checkPortfProjectWidgetsPerms,
      content: <ProjectRequests projName={navProject?.portfProjTitle ?? ''}/>
    },
    {
      type: 'income',
      header: 'Доходы',
      show: checkPortfProjectWidgetsPerms,
      content: <IncomesRegister proj={proj}/>
    },
    {
      type: 'year',
      withoutSection: true,
      show: isCommandManagmentOrProjOffice,
      content: <ProjectReportWidgets/>
    },
    {
      type: 'unified',
      header: 'Унифицированные показатели',
      show: () => hasPermsOnIndexesOrReceipts(userCtx, {
        stratId,
        portfolioId,
        projId
      }),
      content: <UnifiedProjTable/>
    },
    {
      type: 'milestones',
      content: <MilestonesTable/>
    },
    {
      type: 'milestone',
      content: <EditFactForm/>
    },
    {
      type: 'receipts',
      show: (userCtx, stratId, projId, portfolioId) => hasPermsOnIndexesOrReceipts(userCtx, {stratId, projId, portfolioId}),
      content: <Receipts
        stratId={stratId} 
        projId={projId} 
        portfolioId={portfolioId}
        tableLeftValues={[140, 316]}
        type={'portfolioProjectReceipts'}
        totalIndex={2}
      />
    },
    {
      type: 'nreceipt',
      show: isCommandManagmentOrProjOffice,
      content: <ReceiptsAddContract stratId={stratId} projId={projId} portfolioId={portfolioId}/>
    },
    {
      type: 'receipt',
      show: isCommandManagmentOrProjOffice,
      content: <ReceiptEdit stratId={stratId} projId={projId} portfolioId={portfolioId}/>
    },
  ];

  if (content.filter((x) => x.type === type)[0]?.withoutSection) {
    return content.filter((x) => x.type === type && (!x.show || x.show(userCtx, stratId, projId, portfolioId)))[0]?.content ?? <ForbiddenAccess/>;
  }

  return (
    <section className="page project-page">
      <div className="container">
        <BackBtn/>
        {content.filter((x) => x.type === type)[0]?.header && <div>
          <div className="project-title-wrapper" style={{
            paddingBottom: '0',
            color: '#0C0065'
          }}>
            <h2>{content.filter((x) => x.type === type)[0]?.header}</h2>
          </div>
        </div>}
        <div>
          {content.filter((x) => x.type === type && (!x.show || x.show(userCtx, stratId, projId, portfolioId)))[0]?.content ?? <ForbiddenAccess/>}
        </div>
      </div>
    </section>
  );
}

export default PortfProjReportWidgetPage;
